import { makeObjectEquatableKey } from "../../utilities/drcx/MakeObjectEquatableKey";
import { DeviceTypesEnum } from "../../enums/DeviceTypesEnum";
import { RulesEngineRuleTypeEnum } from "../../enums/RulesEngineTypeEnum";
import { DRCXAvailableObjectBase, IDRCXAvailableObjectBase } from "./DRCXAvailableObjectBase";
import { eLynxObjectTypeEnum } from "../../enums/eLynxObjectType";

export interface IDRCXAvailableObject<TKeyType> extends IDRCXAvailableObjectBase<TKeyType> {

    displayText: string;
    id?: number;
    objectType?: eLynxObjectTypeEnum;
    deviceType?: DeviceTypesEnum;
    ruleType?: RulesEngineRuleTypeEnum;
}

export class DRCXAvailableObject extends DRCXAvailableObjectBase<string> implements IDRCXAvailableObject<string> {
    public constructor(displayText: string,
        public id: number,
        public objectType: eLynxObjectTypeEnum,
        public deviceType?: DeviceTypesEnum,
        public ruleType?: RulesEngineRuleTypeEnum,
        public active?: boolean
    ) {
        // super(displayText, makeObjectEquatableKey(objectType, id, deviceType, ruleType));
        super(displayText, makeObjectEquatableKey(objectType, id));
    }
}
